<template>
    <div class="fixed top-0 left-0 right-0 bottom-0 backdrop-blur-[3px] w-screen h-screen z-50" :class="loading.state.active ? 'block' : 'hidden'">
        <div class="absolute top-0 bottom-0 left-0 right-0 w-full h-screen flex flex-col justify-center items-center !m-auto z-[50]">
            <img src="@/assets/gifs/custom-preview-loading.gif" alt="Loading" class="w-[120px] h-[120px]" />
            <div class="flex flex-col gap-12">
                <div class="text-18 text-gray6 font-bold text-center">
                    {{ loading.state.title }}
                </div>
                <div class="text-16 text-gray6 text-center">
                    {{ loading.state.content }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const loading: any = inject("loading");
</script>
